module.exports = __webpack_public_path__ + "28b67065/img/comment-question-icon.7dd26e04.svg";